import React from 'react';
import './Loader.css';

const LoaderGlobal = () => {
  return (
    <div className='loader'></div>
  )
}

export default LoaderGlobal